export const toggleInSet = (set: Set<string>, value: string) => {
  const next = new Set(set)
  next.has(value) ? next.delete(value) : next.add(value)
  return next
}

/** Strip query string and hash from a Next.js `asPath`. */
export const normalizeAsPath = (asPath: string) => asPath.split('?')[0].split('#')[0]
